import flatpickr from "flatpickr";

window.addEventListener('DOMContentLoaded', () => {
	if (typeof flatpickr !== 'undefined') {

		const onFocusOut = (event) => {
			event.target.classList.remove('is-invalid');
			event.target.classList.remove('is-valid');
			setTimeout(() => {
				if (event.target.value) {
					event.target.classList.add('is-valid');
				} else {
					event.target.classList.add('is-invalid');
				}
			}, 150);
		}

		// Date + time picker.
		const elements = document.getElementsByClassName('date-time-picker');
		if (elements.length > 0) {
			[...elements].forEach((element) => {
				if (element.required) {
					element.addEventListener("focusout", onFocusOut);
				}
			flatpickr(element, {
				enableTime: true,
				dateFormat: "Y-m-d H:i",
				time_24hr: true,
				minuteIncrement: 5,
				minDate: "today",
				locale: {
					firstDayOfWeek: 1
				}
			});
			})
		}

		// Date picker.
		const dateElements = document.getElementsByClassName('date-picker');
		if (dateElements.length > 0) {
			[...dateElements].forEach((element) => {
				if (element.required) {
					element.addEventListener("focusout", onFocusOut);
				}
			flatpickr(element, {
				enableTime: false,
				dateFormat: "Y-m-d",
				minDate: "today",
				locale: {
					firstDayOfWeek: 1
				}
			});
			})
		}

		// Time picker.
		const timeElements = document.getElementsByClassName('time-picker');
		if (timeElements.length > 0) {
			[...timeElements].forEach((element) => {
			flatpickr(element, {
				enableTime: true,
				noCalendar: true,
				dateFormat: "H:i",
				time_24hr: true,
				minuteIncrement: 5,
				onClose: () => {
					element.classList.remove('is-invalid');
					element.classList.remove('is-valid');
					setTimeout(() => {
						if (element.value) {
							element.classList.add('is-valid');
						} else {
							element.classList.add('is-invalid');
						}
					}, 150);
				}
			});
			})
		}
	}
});
